import { useEffect, useMemo, useState } from "react";
import { selectFreeGifts, selectProductsInCart, useSelector } from "@jti/store";
export const useFreeGifts = () => {
    const { giftsByProduct, isFreeGiftsEnabled, limit } = useSelector(selectFreeGifts);
    const productsInCart = useSelector(selectProductsInCart);
    const [selectedFreeGifts, setSelectedFreeGifts] = useState({});
    useEffect(() => {
        if (productsInCart.length === 0)
            return;
        const initial = {};
        for (const item of productsInCart) {
            if (!item?.isGift || !item?.parentGiftId)
                continue;
            const parentId = item.parentGiftId;
            const giftSku = item.sku;
            const quantity = item.quantity ?? 0;
            if (!initial[parentId]) {
                initial[parentId] = {};
            }
            initial[parentId][giftSku] = quantity;
        }
        setSelectedFreeGifts(initial);
    }, [productsInCart]);
    const setSelectedFreeGiftQuantity = ({ parentGiftId, giftSku, quantity }) => {
        setSelectedFreeGifts((prev) => ({
            ...prev,
            [parentGiftId]: {
                ...prev[parentGiftId],
                [giftSku]: quantity,
            },
        }));
    };
    const totalNumberOfGiftsAddedToCart = useMemo(() => {
        return Object.values(selectedFreeGifts).reduce((acc, gifts) => {
            return acc + Object.values(gifts).reduce((sum, q) => sum + q, 0);
        }, 0);
    }, [selectedFreeGifts]);
    return {
        giftsByProduct,
        isFreeGiftsEnabled,
        limit,
        selectedFreeGifts,
        setSelectedFreeGiftQuantity,
        totalNumberOfGiftsAddedToCart,
    };
};
//# sourceMappingURL=useFreeGifts.js.map